// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3vEAu","buttons":"SendReceipts_buttons__3OrKd","email":"SendReceipts_email__2aIhc","bookApptTitle":"SendReceipts_bookApptTitle__2omKH"};